import { getSizeFromResizeObserverEntryFactory, getElementDimensionsCallback } from "@contember/utilities";
import { useMemo, useState, useLayoutEffect } from "react";
import { unwrapRefValue } from "./unwrapRefValue.js";
import { useOnElementResize } from "./useOnElementResize.js";
import { useScopedConsoleRef } from "../debug-context/Context.js";
import { useReferentiallyStableCallback } from "../referentiallyStable/useReferentiallyStableCallback.js";
function useElementSize(refOrElement, options = {}, timeout = 300) {
  const { logged } = useScopedConsoleRef("useElementSize").current;
  const { box = "border-box" } = options;
  const getSizeFromResizeObserverEntry = useMemo(() => getSizeFromResizeObserverEntryFactory(box), [box]);
  const [width, setWidth] = useState();
  const [height, setHeight] = useState();
  logged("dimensions", { width, height });
  const maybeSetNewDimensions = useReferentiallyStableCallback((dimensions) => {
    if (width !== dimensions.width) {
      setWidth(dimensions.width);
    }
    if (height !== dimensions.height) {
      setHeight(dimensions.height);
    }
  });
  useOnElementResize(refOrElement, (entry) => {
    const dimensions = logged("useOnElementResize => entry:dimensions", getSizeFromResizeObserverEntry(entry));
    maybeSetNewDimensions(dimensions);
  }, { box }, timeout);
  useLayoutEffect(() => {
    const element = unwrapRefValue(refOrElement);
    if (element) {
      getElementDimensionsCallback(element, (dimensions) => maybeSetNewDimensions(dimensions));
    }
  });
  return { height, width };
}
export {
  useElementSize
};
//# sourceMappingURL=useElementSize.js.map
